import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#A6814A",
    "col1l": "#E0B677",
    "col1n": "#C69C5D",
    "col1s": "#775B31",
    "col2l": "#AC8268",
    "col2n": "#794D32",
    "col2s": "#2A180D"
}
function ObjMor108({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M66.2 12.85L0 0v56.25L66.2 74.3q5.35-31.3 0-61.45z"
                    id="ObjMor108__Symbol_280_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M99.6 21.75l17.1-5.6L52.15 0 0 10.25l66.2 17.8q18.65-1.4 33.4-6.3z"
                    id="ObjMor108__Symbol_279_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M34.1 4.5L0 11.9v56.5l50.5-14.65V0L34.1 4.5z"
                    id="ObjMor108__Symbol_281_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M0 59.35l18.1 4.7v-3.4L0 55.95v3.4M8.5 47.2l-4.15-6.45-.2-.05L0 45v.05l2.55.65v9.85l3.4.9V46.6l2.55.65v-.05m.95.25v.05l2.55.7v9.85l3.4.85v-9.85l2.55.65v-.05l-4.2-6.45-.15-.05-4.15 4.3M41.5 8.1v-.95L21.2 11.9v1.05L41.5 8.1m13.8-3.3L71.7.9V0L55.3 3.9v.9z"
                    id="ObjMor108__Symbol_277_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M13.8 0L0 3.15v25.8l13.8-3.85V0z"
                    id="ObjMor108__Symbol_276_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2l}
                    d="M64.65 20.5l13.8-3.15v-.6h-.05L13.65 0 0 2.65 64.65 20v.5z"
                    id="ObjMor108__Symbol_275_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2s}
                    d="M73.15 15.55l-6.1 1.3q-.15-.2-.3-.2L2.25 0 0 .4q.05.05.1.05l65.4 16.9-6.15 1.45v.95l13.8-3.3v-.9z"
                    id="ObjMor108__Symbol_274_0_Layer0_0_FILL"
                />
                <path
                    fill="#FFF"
                    d="M330.2 317.05l3.65-.75q5.35-1.25 10.8-2.45l-22.4-6.05h-.15q-5.45 1.2-10.8 2.45l-3.25.75 22.15 6.05z"
                    id="ObjMor108__Layer1_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjMor108__Symbol_280_0_Layer0_0_FILL"
                transform="translate(264.3 300.85)"
                id="ObjMor108__col1n"
            />
            <use
                xlinkHref="#ObjMor108__Symbol_279_0_Layer0_0_FILL"
                transform="translate(264.3 290.6)"
                id="ObjMor108__col1l"
            />
            <use
                xlinkHref="#ObjMor108__Symbol_281_0_Layer0_0_FILL"
                transform="translate(330.5 306.75)"
                id="ObjMor108__col1d"
            />
            <use
                xlinkHref="#ObjMor108__Symbol_277_0_Layer0_0_FILL"
                transform="translate(309.3 306.75)"
                id="ObjMor108__col1s"
            />
            <use
                xlinkHref="#ObjMor108__Symbol_276_0_Layer0_0_FILL"
                transform="translate(350.8 311.25)"
                id="ObjMor108__col2n"
            />
            <use
                xlinkHref="#ObjMor108__Symbol_275_0_Layer0_0_FILL"
                transform="translate(286.15 293.9)"
                id="ObjMor108__col2l"
            />
            <use
                xlinkHref="#ObjMor108__Symbol_274_0_Layer0_0_FILL"
                transform="translate(291.45 295.1)"
                id="ObjMor108__col2s"
            />
            <use xlinkHref="#ObjMor108__Layer1_0_FILL" />
        </g></g>
    )
}
export default ObjMor108
